import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router";
import TabsNav from "../../components/TabsNav";
import * as yup from "yup";
import HelpIcon from "@mui/icons-material/Help";
import { ContentStyle, DRxSelectStyle, Note, greyColor } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import DRxSelect from "../../uikit/DRxSelect";
import { useState } from "react";
import { DialogPopup } from "../../components/DialogPopup";
import ss1 from "../../images/screenshots/ssmhx/screenshot1.png";
import ss2 from "../../images/screenshots/ssmhx/screenshot2.png";
import ss3 from "../../images/screenshots/ssmhx/screenshot3.png";
import ss4 from "../../images/screenshots/ssmhx/screenshot4.png";

const consentData = [
  { value: "Y", label: "Yes" },
  { value: "N", label: "No" },
];
const initialDataSSMedicationHistory = {
  Consent: "N",
};

export default function SSMedicationHistory() {
  const navigate = useNavigate();
  const [consent, setConsent] = useState(false);
  const [sSMHHelpPopup, setSSMHHelpPopup] = useState(false);
  const handleShowSSMHHelpPopupClick = () => {
    setSSMHHelpPopup(true);
  };
  const handleHideSSMHHelpPopupClick = () => {
    setSSMHHelpPopup(false);
  };
  return (
    <>
      <TabsNav />
      <ContentStyle>
        <div style={{ width: "100%" }}>
          <Grid
            container
            xs={12}
            spacing={0}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12}>
              <Note style={{ marginBottom: 2 }}>
                <Typography
                  variant="body2"
                  component="div"
                  fontWeight={600}
                  textAlign={"center"}
                >
                  <Typography component="span" variant="body2">
                    NEW SS MEDICATION HISTORY SCREEN:{" "}
                  </Typography>{" "}
                  <Typography component="span" color="primary" variant="body2">
                    PLEASE CLICK ON LINK FOR HELP ---{">"}{" "}
                    <Box
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        cursor: "pointer",
                        position: "relative",
                        fontWeight: 600,
                      }}
                      onClick={() => {
                        setSSMHHelpPopup(true);
                      }}
                    >
                      HELP <HelpIcon />
                    </Box>
                  </Typography>{" "}
                </Typography>
              </Note>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100vh",
          }}
        >
          <div>
            <Grid
              container
              xs={12}
              spacing={3}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12}></Grid>
              <Grid item xs={11}>
                <Typography
                  variant="body2"
                  component="div"
                  textAlign={"center"}
                >
                  Please choose the patient consent level
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={12}>
                <Formik
                  initialValues={initialDataSSMedicationHistory}
                  onSubmit={(values) => {
                    if (values.Consent === "N") {
                      setConsent(true);
                    } else {
                      setConsent(false);
                      navigate("/ssmedicationhistory/records", {
                        state: values,
                      });
                    }
                  }}
                  validationSchema={yup.object().shape({
                    Consent: yup.string().required("Consent is Required"),
                  })}
                >
                  <Form>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item xs={5} textAlign="right">
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="consent"
                          marginRight={2}
                        >
                          Consent
                        </Typography>
                      </Grid>
                      <Grid item xs={7} textAlign="left">
                        <DRxSelectStyle className="w100 " textAlign={"left"}>
                          <DRxSelect
                            name="Consent"
                            id="consent"
                            data={consentData}
                            label="Consent"
                          />
                        </DRxSelectStyle>
                      </Grid>
                      {consent && (
                        <Grid item xs={12} md={12} textAlign="center">
                          <Typography
                            variant="body2"
                            color={"error"}
                            component={"p"}
                          >
                            Medication History cannot be displayed without
                            patient's consent.
                          </Typography>
                        </Grid>
                      )}
                      <Grid xs={5}></Grid>
                      <Grid item xs={7} textAlign="left">
                        <YSButton
                          onClick={null}
                          className=""
                          children={"Get History"}
                          size={"large"}
                          type="submit"
                          color="primary"
                          variant="contained"
                        />
                      </Grid>
                    </Grid>
                  </Form>
                </Formik>
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid
              container
              xs={12}
              spacing={3}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} marginY={5}>
                <Typography variant="subtitle2" marginBottom={1}>
                  Note:
                </Typography>
                <Typography variant="body2" color={"primary"}>
                  1. The patient's Medication History is updated from the
                  Surescript network upon your request, and it is refreshed once
                  every 24 hours.
                </Typography>

                <Typography variant="body2" color={"primary"}>
                  2. Retrieving and processing the Medication History from the
                  Surescript network typically takes around 10 to 15 seconds.
                </Typography>

                <Typography variant="body2" color={"primary"}>
                  3. Please note that if you do not have benefits, Surescripts
                  will be unable to provide your Medication History. In such
                  cases, the information may not be available.
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
        <DialogPopup
          windowsize={"lg"}
          show={sSMHHelpPopup}
          handleShowPopupClick={handleShowSSMHHelpPopupClick}
          handleHidePopupClick={handleHideSSMHHelpPopupClick}
          title={"SS Medication History Help Guide"}
        >
          <Grid
            container
            item
            xs={12}
            spacing={3}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12}>
              <Typography variant="body2" component={"p"} marginBottom={2}>
                "Benefit Source History" as it was previously known, came from
                the Surescripts and the patients PBM and was available if and
                only if the patient's PBM was part of the SS network and a claim
                was generated for the prescription. These included all
                prescriptions prescribed by any physician anywhere in the
                country as long as a claim was generated for that prescription
                and the PBM who paid the claim was part of Surescripts network.
              </Typography>
              <Typography variant="body2" component={"p"}>
                This is to bring to your notice that the current "Benefit Source
                History" has been renamed the "SS Medication History". It will
                have 2 types of data now 'PBM' and 'Fills'. PBM option provides
                the same information about prescriptions as we had in the past.
                The only change is that now Surescripts requires that the
                patient has given consent for the user to view their
                medications. To enforce this, we have introduced a new drop down
                as shown in the screen-shot below. You need to select "Yes" for
                Surescripts to return the medication list. (If Patient has given
                consent to the prescriber to view their medication history and
                Fills).
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component={"h6"}>
                ScreenShot 1. You can choose consent Level yes to view History
              </Typography>
              <img
                src={ss1}
                style={{ maxWidth: "100%" }}
                alt="ss1"
                loading="lazy"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component={"h6"}>
                ScreenShot 2. Click on get History to see ss MedicationHistory
              </Typography>
              <Typography variant="body2" component="div" marginBottom={1}>
                *<b>Source: </b> <b>P2</b> - Pharmacy/Fills, <b>PY</b> -
                Payer/PBM.
              </Typography>
              <img
                src={ss2}
                style={{ maxWidth: "100%" }}
                alt="ss2"
                loading="lazy"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component={"h6"}>
                ScreenShot 3. To see the details of drug just hover cursor on
                icon like below screen-shot.
              </Typography>
              <img
                src={ss3}
                style={{ maxWidth: "100%" }}
                alt="ss3"
                loading="lazy"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component={"h6"}>
                ScreenShot 4. To see the pharmacy Name of just hover cursor on
                icon like below screen-shot
              </Typography>
              <img
                src={ss4}
                style={{ maxWidth: "100%" }}
                alt="ss4"
                loading="lazy"
              />
            </Grid>
          </Grid>
        </DialogPopup>
      </ContentStyle>
    </>
  );
}
